import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class SalesOrderArrivedActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Bakery/SalesOrderOnline/SalesOrderHistoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="SalesOrder.arrivedBrowse"
				RenderedComponent={this.RenderedComponent}
				context="arrived"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(SalesOrderArrivedActivity)
